import { ErrorBoundary } from '@/pages/time-off-calendar/admin/admin-calendar.error';

export default ErrorBoundary;
